import { PageError } from 'components/shared';
import PageLoader from 'components/shared/PageLoader';
import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { Helmet } from 'react-helmet';
import NPALayoutAuctioneer2 from './NPALayout2';

const AuctioneerScreenView = () => {
  const {
    AuctionStore: { getLayoutSettingByProp, setProperty },
  } = useStores();

  const settings = getLayoutSettingByProp('layoutType', 'Auctioneer');
  setProperty('onClerkScreen', true);

  if (!settings || !settings?.layout) return <PageLoader />;

  if (settings?.layout.indexOf('Auctioneer Screen') > -1) {
    return (
      <>
        <Helmet>
          <title>Auctioneer Screen</title>
        </Helmet>
        <NPALayoutAuctioneer2 />
      </>
    );
  }
  return <PageError />;
};

export default observer(AuctioneerScreenView);
